import "../css/about.css";
import tomc_logo_pattern_fill from "../img/tomc_logo_pattern_fill.png";

const About = () => {
  return (
    <div id="about_hero">
      <div id="hero_text" data-aos="fade-up">
        <h1>About me...</h1>
        <div id="hero_copy">
          <h4>
            My name is Tom.
            <br />
            <br />
            I'm studying Immersive Digital Media and Spatial Computing.
            <br />
            <br />
            I grew up with Dyslexia, although it was not recognized until much
            later in my education. This meant had to find alternative ways to
            read and learn. I would often try and condense what I was learning
            in school down to its simplest form in order to fully understand
            what I was reading, often written on a single cue card.
            <br />
            <br />I called these cue cards my cheat sheets.
          </h4>
        </div>
      </div>
      <div id="hero_image" data-aos="fade-left">
        <img src={tomc_logo_pattern_fill} alt="tomc_logo_pattern_fill.png" />
      </div>
    </div>
  );
};

export default About;
